import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const SubsidySchemeCTA = ({ scheme }) => (
  <section className={`py-20 bg-gradient-to-r ${scheme.color}`}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
      <h2 className="font-heading text-3xl font-semibold text-white mb-4">
        Ready to Apply for {scheme.name}?
      </h2>
      <p className="text-white/80 max-w-2xl mx-auto mb-8">
        Our experts will help you understand eligibility, prepare documentation, 
        and guide you through the entire application process.
      </p>
      <Link
        to="/contact"
        className="px-10 py-4 bg-white text-[#0f172a] rounded-full font-medium hover:bg-white/90 transition-colors inline-flex items-center gap-2"
      >
        Get Started Today
        <ArrowRight size={18} />
      </Link>
    </div>
  </section>
);
